import { useContext, useEffect, useState } from 'react';
import { Field } from 'formik'
import { TextField } from 'formik-material-ui';
import { Grid, Card, CardContent, CardHeader, InputAdornment, Button, CircularProgress, colors } from '@material-ui/core';
import { Select, FieldError } from '../../../../common'
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { SapTableNames } from '../../../../../helpers';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { DbType, RequestStatus } from '../../../../../helpers/Common';
import { percentageField } from '../../../../../helpers/Utils';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    loader: {
        color: "black"
    },    
    sapOk: {
        color: colors.green[500]
    },
    sapError: {
        color: colors.red[500]
    }    
}));

export const SalesInfoForm = (props) => {
    const classes = useStyles();

    const {
        state,
        getTableOptionsWithCode,
        getSalesGroupOptions,
        getRespAreasOptions,
        getSalesOfficeOptions,
        getUserBusinessCategoryOptions,
        getUserCompanyOptions,
        getSalesOrgsOptions,
        //getCg6_Options,
        getCg7_Options,
        getCg8_Options,
        getCg9_Options,
        getCg10_Options,
        //getDistributionChannelsOptions,
        getCustomerGroupOptionsS4,
        getCustomerGroupOptionsECC,
        //isLoadingAGMS4,
        getFilteredCg6FromAGMS4,
        getFilteredDistributionChannelFromAGMS4,
        validateSapCode
    } = useContext(CustomerRequestContext);

    const { errors } = state;
    const { values, setFieldValue } = useContext(TabsContext);

    const [isValidatingSapCode, setIsValidatingSapCode] = useState(false);
    const [isSapCodeOk, setIsSapCodeOk] = useState(null);
    const [userCompanyOptions, setUserCompanyOptions] = useState(getUserCompanyOptions());
    const [userBusinessCategoryOptions, setUserBusinessCategoryOptions] = useState(getUserBusinessCategoryOptions());
    const [salesOrganizationOptions, setSalesOrganizationOptions] = useState(getSalesOrgsOptions());

    const checkSapCodeClickHandler = async () => {        
        const sapCode = values.masterCode;
        if (sapCode){
            setIsValidatingSapCode(true);
            setIsSapCodeOk(null);
            const isValid = await validateSapCode(sapCode, values.dbType);
            setIsSapCodeOk(isValid);
            setIsValidatingSapCode(false);
        }
    }

    const salesGroupOptions = getSalesGroupOptions();
    const respAreaOptions = getRespAreasOptions();
    const salesOfficeOptions = getSalesOfficeOptions();
    const cg6_Options = /*!isLoadingAGMS4 && state.custGroupsWithAccGroupS4.length > 0 ? */getFilteredCg6FromAGMS4(values.customerGroupId)/* : getCg6_Options()*/;
    const cg7_Options = getCg7_Options();
    const cg8_Options = getCg8_Options();
    const cg9_Options = getCg9_Options();
    const cg10_Options = getCg10_Options();
    const distributionChannelsOptions = /*!isLoadingAGMS4 && state.custGroupsWithAccGroupS4.length > 0 ? */getFilteredDistributionChannelFromAGMS4(values.customerGroup6Id)/* : getDistributionChannelsOptions()*/;
    const cgS4_Options = getCustomerGroupOptionsS4();
    const cgECC_Options = getCustomerGroupOptionsECC();
    const salesDistrictOptions = getTableOptionsWithCode(SapTableNames.SalesDistricts, values.dbType, null, true);

    useEffect(() => {
        if (
            values.dbType === DbType.ECC &&
            !!state.requestObsoleteSavedData &&
            !!state.request &&
            (
                state.request.status === RequestStatus.Approved ||
                state.request.status === RequestStatus.Closed ||
                state.request.status === RequestStatus.Rejected ||
                state.request.status === RequestStatus.Deleted
                
            )
        ){
            const savedCompany = {
                dbType: values.dbType,
                externalKey: state.requestObsoleteSavedData.company.externalKey,
                tableValueId: state.requestObsoleteSavedData.company.tableValueId,
                value: state.requestObsoleteSavedData.company.value
            };

            setUserCompanyOptions(getUserCompanyOptions(savedCompany));

            const savedBusinessCategory = {
                dbType: values.dbType,
                externalKey: state.requestObsoleteSavedData.businessCategory.externalKey,
                tableValueId: state.requestObsoleteSavedData.businessCategory.tableValueId,
                value: state.requestObsoleteSavedData.businessCategory.value
            };

            setUserBusinessCategoryOptions(getUserBusinessCategoryOptions(savedBusinessCategory));

            const savedSalesOrganization = {
                dbType: values.dbType,
                externalKey: state.requestObsoleteSavedData.salesOrganization.externalKey,
                tableValueId: state.requestObsoleteSavedData.salesOrganization.tableValueId,
                value: state.requestObsoleteSavedData.salesOrganization.value
            };

            setSalesOrganizationOptions(getSalesOrgsOptions(savedSalesOrganization));
        }
    }, [state.requestObsoleteSavedData, state.request]);

    useEffect(() => {
        if (
            values.dbType === DbType.ECC &&
            !!state.requestObsoleteSavedData &&
            !!state.request &&
            (
                state.request.status === RequestStatus.Approved ||
                state.request.status === RequestStatus.Closed ||
                state.request.status === RequestStatus.Rejected ||
                state.request.status === RequestStatus.Deleted
                
            )
        )
            setFieldValue("companyId", state.requestObsoleteSavedData.company.tableValueId);
    }, [state.userCompanies, state.request]);

    useEffect(() => {
        if (
            values.dbType === DbType.ECC &&
            !!state.requestObsoleteSavedData &&
            !!state.request &&
            (
                state.request.status === RequestStatus.Approved ||
                state.request.status === RequestStatus.Closed ||
                state.request.status === RequestStatus.Rejected ||
                state.request.status === RequestStatus.Deleted
                
            )
        )
            setFieldValue("businessCategoryId", state.requestObsoleteSavedData.businessCategory.tableValueId);
    }, [state.userBusinessCategories, state.request]);

    useEffect(() => {
        if (
            values.dbType === DbType.ECC &&
            !!state.requestObsoleteSavedData &&
            !!state.request &&
            (
                state.request.status === RequestStatus.Approved ||
                state.request.status === RequestStatus.Closed ||
                state.request.status === RequestStatus.Rejected ||
                state.request.status === RequestStatus.Deleted
                
            )
        )
            setFieldValue("salesOrganizationId", state.requestObsoleteSavedData.salesOrganization.tableValueId);
    }, [state.userSalesOrgs, state.request]);

    return (
        <Card>
            <CardHeader title="Sales Information" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={4} md={12} xs={12}>
                        <Select
                            name="salesGroupId"
                            helperText="It has been assigned to you"
                            label="Sales group *"
                            disabled={props.disabled || salesGroupOptions.length === 1}
                            options={salesGroupOptions}
                        />
                        <FieldError name="salesGroupId" errors={errors} />
                    </Grid>
                    <Grid item xl={4} md={12} xs={12}>
                        <Select
                            name="responsibilityAreaId"                            
                            label="Responsability area *"
                            helperText="It depends on the Sales Group"
                            disabled={props.disabled || respAreaOptions.length === 1}
                            options={respAreaOptions}
                        />
                        <FieldError name="responsibilityAreaId" errors={errors} />
                    </Grid>
                    <Grid item xl={4} md={12} xs={12}>
                        <Select
                            name="businessCategoryId"
                            label="Business category *"
                            helperText="It has been assigned to you"
                            disabled={props.disabled || userBusinessCategoryOptions.length === 1}
                            options={userBusinessCategoryOptions}
                        />
                        <FieldError name="businessCategoryId" errors={errors} />
                    </Grid>
                    <Grid item xl={4} md={12} xs={12}>
                        <Select
                            disabled
                            name="companyId"
                            label="Company *"
                            helperText="It has been assigned to you"
                            options={userCompanyOptions}
                        />
                        <FieldError name="companyId" errors={errors} />
                    </Grid>
                    <Grid item xl={4} md={12} xs={12}>
                        <Select
                            name="salesOrganizationId"                            
                            label="Sales organization *"
                            helperText="It depends on the Company"
                            disabled={props.disabled || salesOrganizationOptions.length === 1}
                            options={salesOrganizationOptions}
                        />
                        <FieldError name="salesOrganizationId" errors={errors} />
                    </Grid>
                    <Grid item xl={4} md={12} xs={12}>
                        <Select
                            name="salesOfficeId"
                            helperText="It depends on the Sales Organization"
                            label="Sales office *"
                            disabled={props.disabled || salesOfficeOptions.length === 1}
                            options={salesOfficeOptions}
                        />
                        <FieldError name="salesOfficeId" errors={errors} />
                    </Grid>

                    {
                        state.request.dbType === DbType.S4 ?
                        <>
                            <Grid item xl={4} md={12} xs={12}>
                                <Select
                                    name="customerGroup6Id"
                                    label="Customer Group 6 - Sales Channel Level 3 *"
                                    helperText="It depends on the Customer Group"
                                    disabled={
                                        props.disabled ||
                                        values.customerGroupId === "" ||
                                        cg6_Options.length === 1
                                    }
                                    options={cg6_Options}
                                />
                                <FieldError name="customerGroup6Id" errors={errors} />
                            </Grid>

                            <Grid item xl={4} md={12} xs={12}>
                                <Select
                                    name="customerGroup7Id"
                                    label="Customer Group 7 - Price Type *"
                                    helperText="It depends on the Sales Organization"
                                    disabled={props.disabled || cg7_Options.length === 1}
                                    options={cg7_Options}
                                />
                                <FieldError name="customerGroup7Id" errors={errors} />
                            </Grid>

                            <Grid item xl={4} md={12} xs={12}>
                                <Select
                                    name="customerGroup8Id"
                                    label="Customer Group 8 - Network Type *"
                                    helperText="It depends on the Sales Organization"
                                    disabled={props.disabled || cg8_Options.length === 1}
                                    options={cg8_Options}
                                />
                                <FieldError name="customerGroup8Id" errors={errors} />
                            </Grid>

                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="customerGroup9Id"
                                    label="Customer Group 9 - Operating Country/Region *"
                                    helperText="It depends on the Sales Organization"
                                    disabled={props.disabled || cg9_Options.length === 1}
                                    options={cg9_Options}
                                />
                                <FieldError name="customerGroup9Id" errors={errors} />
                            </Grid>

                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="customerGroup10Id"
                                    label="Customer Group 10 - Responsibility Area Level 4 *"
                                    helperText="It depends on the Responsibility Area"
                                    disabled={props.disabled || cg10_Options.length === 1}
                                    options={cg10_Options}
                                />
                                <FieldError name="customerGroup10Id" errors={errors} />
                            </Grid>

                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="distributionChannelId"
                                    label="Distribution Channel - Sales Channel Level 2 *"
                                    helperText="It depends on the Customer Group 6"
                                    disabled={
                                        props.disabled ||
                                        values.customerGroup6Id === "" ||
                                        distributionChannelsOptions.length === 1
                                    }
                                    options={distributionChannelsOptions}
                                />
                                <FieldError name="distributionChannelId" errors={errors} />
                            </Grid>

                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="customerGroupId"
                                    label="Customer group *"
                                    //helperText="It depends on the Sales Organization"
                                    disabled={props.disabled || cgS4_Options.length === 1}
                                    options={cgS4_Options}
                                />
                                <FieldError name="customerGroupId" errors={errors} />
                            </Grid>
                        </> :
                        <Grid item xl={6} md={12} xs={12}>
                            <Select
                                name="customerGroupId"
                                label="Customer group *"
                                helperText="It depends on the Sales Organization and Business Category"
                                disabled={props.disabled || cgECC_Options.length === 1}
                                options={cgECC_Options}
                            />
                            <FieldError name="customerGroupId" errors={errors} />
                        </Grid>
                    }

                    <Grid item xl={state.request.dbType === DbType.S4 ? 12 : 6} md={12} xs={12}>
                        <Select
                            name="salesDistrictId"
                            label="Sales district"
                            disabled={props.disabled || salesDistrictOptions.length === 1}
                            options={salesDistrictOptions}
                        />
                        <FieldError name="salesDistrictId" errors={errors} />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="masterCode"
                            label="Master code"
                            disabled={props.disabled}
                            component={TextField}
                            InputProps={{
                                endAdornment:
                                    values.dbType === DbType.S4 ?
                                    <></> :                     
                                    <InputAdornment position="end">
                                        <Button
                                            startIcon={
                                                isValidatingSapCode ?
                                                <CircularProgress size={20} className={classes.loader} /> :
                                                <>
                                                    {
                                                        isSapCodeOk === null ? 
                                                        "" :
                                                        isSapCodeOk === true ? <CheckIcon className={classes.sapOk} /> : <CloseIcon className={classes.sapError}/>
                                                    }
                                                </>
                                            }
                                            disabled={props.disabled}
                                            onClick={checkSapCodeClickHandler}
                                        >
                                            Check
                                        </Button>
                                    </InputAdornment>                        
                            }}
                        />
                        <FieldError name="masterCode" errors={errors} />
                    </Grid>

                    {
                        state.request.dbType === DbType.S4 &&
                        <>
                            <Grid item xl={6} md={12} xs={12}>
                                <Field
                                    className={classes.field}
                                    variant="outlined"
                                    name="royaltiesPercentage"
                                    label="Royalties percentage"
                                    disabled={props.disabled}
                                    component={percentageField}
                                />
                                <FieldError name="royaltiesPercentage" errors={state.errors} />
                            </Grid>

                            <Grid item xl={6} md={12} xs={12}>
                                <Field
                                    className={classes.field}
                                    variant="outlined"
                                    name="marketingContributionPercentage"
                                    label="Marketing Contribution percentage"
                                    disabled={props.disabled}
                                    component={percentageField}
                                />
                                <FieldError name="marketingContributionPercentage" errors={state.errors} />
                            </Grid>

                            <Grid item xl={12} md={12} xs={12}>
                                <Field
                                    disabled
                                    name="exchangeRateType"
                                    label="Exchange rate type *"
                                    helperText="Please if the Exchange Rate Type needs to be different for this customer, refer to the Pricing Unit team"
                                    type="text"
                                    style={{ width: "100%" }}
                                    variant="outlined"
                                    component={TextField}
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}